import React, { useEffect, useState } from "react";
import { Card, Col, Table } from "react-bootstrap";
 
import { useNavigate, useParams } from "react-router-dom";
import { Badge, Dropdown } from "react-bootstrap";

import toast from "react-hot-toast";
import Lottie from "lottie-react";
import animationData from "../../images/loding.json";
 
import Pagination from "../components/Pagination";
import {
  blockUser,
  getUserDetail,
  getUserEvent,
  getUserList,
} from "../../services/UserServices/UserService";
import { useLocation } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
 

export default function Guest(props) {
  const location = useLocation();
  const historyData = location.state?.history;
 
  
  const [loader, setLoader] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  // const [isBlocked, setIsBlocked] = useState(false);
   const { id1,id2 } = useParams();

    
  
const [user, setUser] = useState();
  const [userEvent, setUserEvent] = useState([]);
  const [loading, setLoading] = useState(true);
 
  useEffect(() => {
      const getData = async () => {
      
        try {
          setLoading(true); 
          const res = await getUserDetail(id1);
          
          setUser(res?.data?.data);
         
        } catch (error) {
          console.error(error?.response?.data?.message);
        }
        finally{
          setLoading(false);
        }
      };
      if (id1) {
        getData();
      }
     }, []);
  
  useEffect(() => {
     const getEvent = async () => {
       try {
         const res = await getUserEvent(id2);
         
         setUserEvent(res?.data?.data);
         
       } catch (error) {
         console.error(error?.response?.data?.message);
       }
     };
     if (id2) {
 
       getEvent();
     }
   }, []);
    











  const guests = [
    {
      id: 1,
      name: "abc",
      phone: 2132323312321,
      invites:"Wedding , Haldi , Mehandi",
      status:"Accepted"
    },
    {
      id: 2,
      name: "xyz",
      phone: 2132323312321,
       invites:"Wedding , Haldi , Mehandi",
      status:"Rejected"
    },
    {
      id: 3,
      name: "uvw",
      phone: 2132323312321, invites:"Wedding , Haldi , Mehandi",
      status:"Accepted"
    },
    {
      id: 4,
      name: "sdf",
      phone: 2132323312321, invites:"Wedding , Haldi , Mehandi",
      status:"Rejected"
    },
  ];








  // async function handleTableList() {
  //   setLoader(true);
  //   try {
  //     const res = await getUserList(currentPage, 10, search);
  //     setTableData(res?.data?.data?.users);
  //     setTotalPages(res?.data?.data?.count);
  //     setLoader(false);
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message);
  //   } finally {
  //     setLoader(false);
  //   }
  // }
 

 

  // useEffect(() => {
  //   setCurrentPage(0);
  //   const delayDebounce = setTimeout(() => {
  //     handleTableList();
  //   }, 500);

  //   return () => clearTimeout(delayDebounce);
  // }, [search]);

  // useEffect(() => {
  //   handleTableList();
  // }, [currentPage]);

  

  const totalItems = totalPages;
  const total = Math.ceil(totalItems / 10);

 

  return (
 <div >

    <PageTitle
          motherMenu="User List"
          activeMenu={`${historyData.user?.hostName} >  ${historyData.event?.name?.name || "Event"} > Guests`}
          pathBack={true}   
        />
      {/* -------- User Detail Card -------- */}
      <h2
        className="mb-4 user-detail-title font-fm"
        style={{ fontSize: "50px" }}
      >
{/* {historyData.user?.hostName}  {historyData.event?.name?.name || "Event"} {`>`} {"Guests"} */}

      </h2>
    
      <div className="pb-2 d-flex justify-content-between">
        <input  
          type="text"
          style={{ borderRadius: "0.5rem", width: "100%" }}
          className="form-control inpp"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <Col>
        {loader ? (
          <div>
            <Lottie
              style={{
                height: "200px",
                marginTop: "45px",
                padding: "30px",
              }}
              animationData={animationData}
            />
          </div>
        ) : (
          <Card>
            <Card.Body>
              <Table responsive>
                <thead style={{color:"#A60000"}}>
                  <tr>
                    <th>
                      <strong>S.NO</strong>
                    </th>
                  
                    <th>
                      <strong>Name</strong>
                    </th>
                  
                    <th>
                      <strong>Phone Number</strong>
                    </th>
                   


                    <th>
                      <strong>More Invites </strong>
                    </th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  {guests.map((guest, index) => (
                    <tr style={{  color: "#A60000"}} key={index}>
                      <td>{index + 1 + currentPage * itemsPerPage}</td>
                    
                      
                      <td>
                        <span className="w-space-no">{guest?.name}</span>
                      </td>
 
                      
                      <td>
                        <span className="w-space-no">
                            {guest?.phone}
                        </span>
                      </td>
             <td>
                       {guest?.invites}
                      </td>
                      <td className={`${guest?.status==="Accepted"?"acc1":"rej1"}`}>
                       {guest?.status  }
                      </td>
                      <td>
                       <Dropdown>
 
</Dropdown>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {/* {tableData?.length === 0 && (
                <div className="justify-content-center d-flex my-5 ">
                  Sorry, Data Not Found!
                </div>
              )}
              {tableData.length !== 0 && (
                <div className="card-footer clearfix">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="dataTables_info" style={{color:"#A60000"}}>
                      Page {currentPage * itemsPerPage + 1} to{" "}
                      {totalItems > (currentPage + 1) * itemsPerPage
                        ? (currentPage + 1) * itemsPerPage
                        : totalItems}{" "}
                      of {totalItems} entries
                    </div>

                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px" }}
                    >
                      <Pagination
                        pageCount={total}
                        pageValue={currentPage}
                        setPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              )} */}
            </Card.Body>
          </Card>
        )}
      </Col>
     
    </div>
  );
}
